import { render } from "./file-status.vue?vue&type=template&id=2af3910c&ts=true"
import script from "./file-status.vue?vue&type=script&lang=ts"
export * from "./file-status.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__